module.exports = __webpack_public_path__ + "img/lunette.95093f51.jpg";